import StepShell from "../StepShell";
import RecipientPicker from "../inputs/RecipientPicker";
import { ACTION_META } from "../leadActions";

/**
 * Quem recebe o lead quente — pessoa ou departamento DENTRO da plataforma
 * (nunca um WhatsApp externo). Só aparece quando a ação escolhida precisa de
 * um destinatário.
 */
export default function LeadsDestino({ briefing, autosave }) {
  const leadHandling = briefing.leadHandling || {};
  const meta = ACTION_META[leadHandling.hotAction] || {};

  function persist(recipient) {
    autosave({ leadHandling: { ...leadHandling, recipient } });
  }

  return (
    <StepShell
      title={meta.recipientTitle || "Quem recebe o lead quente?"}
      description={
        meta.recipient === "optional"
          ? "Opcional — se ninguém for escolhido, o lead entra sem responsável definido."
          : "Escolha uma pessoa ou um departamento da sua conta."
      }
    >
      {meta.note && (
        <p className="mb-5 rounded-xl border border-border bg-surface-inset/40 p-3.5 text-sm text-muted-foreground">
          {meta.note}
        </p>
      )}
      <RecipientPicker
        label={meta.recipientLabel || "Transferir para"}
        value={leadHandling.recipient || null}
        onChange={persist}
      />
    </StepShell>
  );
}
